"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _formModal = require("../../styles/formModal"),
    _ModalFooter = _interopRequireDefault(require("./ModalFooter")),
    _ModalHeader = _interopRequireDefault(require("./ModalHeader")),
    _BaseModal = _interopRequireDefault(require("../BaseModal"));

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var FormModal = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.handleSave = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a() {
      var b, c, e, f;
      return _regenerator["default"].wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              if (b = d.props, c = b.onClose, e = b.onSave, f = b.stayOpenOnSave, e) {
                a.next = 3;
                break;
              }

              return a.abrupt("return");

            case 3:
              return d.setState({
                saving: !0
              }), a.next = 6, e();

            case 6:
              d.setState({
                saving: !1
              }, function () {
                f || c();
              });

            case 7:
            case "end":
              return a.stop();
          }
        }
      }, a);
    })), d.state = {
      saving: !1
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this.props,
          b = a.visible,
          c = a.onClose,
          d = a.children,
          e = a.saveText,
          f = a.closeText,
          g = a.title,
          h = a.subtitle,
          i = a.onSave,
          j = a.saveDisabled,
          k = a.showBackBtn,
          l = a.onBackClick,
          m = a.hideFooter,
          n = this.state.saving;
      return _react["default"].createElement(_BaseModal["default"], {
        visible: b,
        onClose: c
      }, g && _react["default"].createElement(_ModalHeader["default"], {
        title: g,
        subtitle: h,
        showBackBtn: k,
        onBackClick: l
      }), _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_formModal.CONTENT, "modal__content")
      }, d), !m && _react["default"].createElement(_ModalFooter["default"], {
        className: "modal__footer",
        saveText: e,
        closeText: f,
        onClose: c,
        onSave: i ? this.handleSave : void 0,
        saving: n,
        saveDisabled: j
      }));
    }
  }]), b;
}(_react.Component);

exports["default"] = FormModal, FormModal.defaultProps = {
  saveText: "Save Changes",
  stayOpenOnSave: !1
};